import { api, endpoints } from "api/api";
import { CourseTrainerApi, TrainerApi } from "api/types";
import { AxiosPromise } from "axios";

const fetchByCourseId = (courseId: number): AxiosPromise<CourseTrainerApi[]> => {
  return api.get<CourseTrainerApi[]>(endpoints.COURSE_TRAINERS.GET_BY_COURSEID(courseId));
};

export const courseTrainersApi = {
  fetchByCourseId,
};
